export const mainBg = require("./mainBg.png");
export const maniBgr = require("./maniBgr.png");
export const menu = require("./menu.png");
export const logout = require("./logout.png");
export const logo = require("./logo.png");
export const about_icon = require("./about.png");
export const faq_icon = require("./faq.png");
export const help_icon = require("./help.png");
export const notification_icon = require("./push.png");
export const user_icon = require("./user.png");
export const blocked_icon = require("./Blocked.png");
export const food_icon = require("./food.png");
export const order_icon = require("./Order.png");
export const Grown = require("./Grown.png");
export const transaction_icon = require("./Transactions.png");
export const dashboar_icon = require("./dashboard.png");
export const role_icon = require("./role.png");
export const admin_icon = require("./admin.png");
export const profile_img = require("./ProfileImg.png");
export const backArrow_icon = require("./backArrow.png");
export const img1 = require("./img1.jpg");
export const img2 = require("./img2.jpg");
export const UserSubscription = require("./UserSubscription.png");
export const ArrowsLeftRight = require("./ArrowsLeftRight.png");
export const Crown2 = require("./Crown2.png");

//dashboard
export const sold = require("./sold.png");
export const available = require("./available.png");
export const customer = require("./customer.png");
export const cancelled = require("./cancelled.png");
export const amount = require("./amount.png");
export const edit_icon = require("./edit-icon.png");

export const CirclesFour = require("./CirclesFour.png");
export const videoIcon = require("./video.png");
export const Trash = require("./Trash.png");
export const pincode = require("./pincode.png");
export const excelDown = require("./excelDown.jpg");
export const editIcon = require("./editIcon.png");
export const addIcon = require("./addIcon.png");
export const partner = require("./partner.png");
export const withdrawSide = require("./withdrawSide.png");
export const walletSide = require("./walletSide.png");
export const commision = require("./commision.png");

export const approve = require("./approve.png");
export const verified_user = require("./verified_user.png");
export const reject = require("./reject.png");
export const unaccept = require("./unaccept.png");